function systemDashboardReducer(state = [], action) {
    const { type, payload } = action;
    let locations = []

    switch(type) {
        case "GET_DEFAULT_LOCATIONS_SUCCESS":
            let default_location = "";
            let locationName = "";
            locations = payload.locations.map((loc, index) => {
                if(loc.DEFAULT_LOCATION == 1) {
                    default_location = loc.ZLLOC;
                    locationName = loc.ZLLOC+" "+loc.ZLNAME;
                }
                return {
                    key: `loc_${index}`,
                    text: loc.ZLLOC+" "+loc.ZLNAME,
                    value: loc.ZLLOC
                }
            });
            if(!!state.loc)
                default_location = state.loc;
            return Object.assign({}, state, { locations, loc: default_location, locationName });

        case "SET_LOCATION":
            return Object.assign({}, state, { ...payload });

        default:
            return state;
    }
}

export default systemDashboardReducer;